export default function className(
  ...classes: Array<string | Record<string, unknown> | (() => string)>
): string {
  return classes
    .flatMap((definition) => {
      if (typeof definition === "string") {
        return definition;
      }

      if (typeof definition === "function") {
        return definition();
      }

      return Object.entries(definition)
        .filter(([, enabled]) => !!enabled)
        .map(([klass]) => klass);
    })
    .join(" ");
}
